<script>
import {
  shippingMethodListEmits,
  shippingMethodListProps,
  useShippingMethodList
} from "./mixin";
import ShippingMethod from "@/containers/shipping-method";
import List from "@/components/molecules/list";
import ListItem from "@/components/molecules/list/list-item";
import ShippingMethodDetail from "@/containers/shipping-method/shipping-method-detail";
import Popin from "@/containers/popin-adaptive";
import Button from "@/components/atoms/button";
import CmsFetcher from "@/containers/cms-fetcher";

export default {
  name: "ShippingMethodList",
  components: {
    ShippingMethod,
    ShippingMethodDetail,
    List,
    ListItem,
    Popin,
    Button,
    CmsFetcher
  },
  props: {
    ...shippingMethodListProps()
  },
  emits: [...shippingMethodListEmits()],
  setup(props, context) {
    const {
      modeCommandeHabituel,
      otherModesCommande,
      modeCommandeSelected,
      serviceSelected,
      showOrderDetail
    } = useShippingMethodList(props, context);
    return {
      modeCommandeHabituel,
      otherModesCommande,
      modeCommandeSelected,
      serviceSelected,
      showOrderDetail
    };
  },
  data() {
    return {
      isYperTarifsShow: false
    };
  },
  methods: {
    showTarifsYper() {
      this.isYperTarifsShow = true;
    }
  }
};
</script>

<template>
  <div>
    <template v-if="modesCommande.length > 0">
      <template v-if="modesCommande.length > 1">
        <p class="u-font-14 u-mb-md">
          Merci de choisir la manière dont vous souhaitez récupérer votre
          commande
        </p>
        <template v-if="modeCommandeHabituel">
          <div class="c-shipping-method-list__step-subtitle c-shipping-method-list__step-subtitle--dotted u-mt-md">
            <p class="u-mr-xs">
              Votre mode de livraison habituel
            </p>
          </div>
          <!-- <ShippingMethodListDemoFavorite /> -->
          <ShippingMethod
            :mode-commande="modeCommandeHabituel"
            :selected="selectedModeCommandeType === modeCommandeHabituel.type"
            @click="modeCommandeSelected(modeCommandeHabituel)"
            @showOrderDetail="showOrderDetail"
            @openPopinTarifsYper="showTarifsYper"
          >
            <ShippingMethodDetail
              :mode-commande="modeCommandeHabituel"
              @serviceSelected="serviceSelected"
              @openPopinTarifsYper="showTarifsYper"
            />
          </ShippingMethod>
        </template>
        <div
          v-if="modeCommandeHabituel && otherModesCommande.length > 0"
          class="c-shipping-method-list__step-subtitle c-shipping-method-list__step-subtitle--dotted u-mt-md"
        >
          <p class="u-mr-xs">
            Les autres modes de livraison
          </p>
        </div>
        <List class="c-shipping-method-list">
          <ListItem
            v-for="mdc in otherModesCommande"
            :key="mdc.type"
          >
            <ShippingMethod
              :mode-commande="mdc"
              :selected="selectedModeCommandeType === mdc.type"
              @click="modeCommandeSelected(mdc)"
              @showOrderDetail="showOrderDetail"
              @openPopinTarifsYper="showTarifsYper"
            >
              <ShippingMethodDetail
                :mode-commande="mdc"
                @serviceSelected="serviceSelected"
                @openPopinTarifsYper="showTarifsYper"
              />
            </ShippingMethod>
          </ListItem>
        </List>
      </template>
      <template v-else>
        <List class="c-shipping-method-list">
          <ListItem>
            <ShippingMethod
              :mode-commande="modesCommande[0]"
              :selected="selectedModeCommandeType === modesCommande[0].type"
              @click="modeCommandeSelected(modesCommande[0])"
              @showOrderDetail="showOrderDetail"
            >
              <ShippingMethodDetail
                :mode-commande="modesCommande[0]"
                @serviceSelected="serviceSelected"
              />
            </ShippingMethod>
          </ListItem>
        </List>
      </template>
    </template>
    <template v-else>
      <p class="u-bgcolor-white u-radius-lg u-p-sm u-font-700">
        Désolé, mais aucun mode de livraison n'est disponible pour ce panier dans
        ce magasin pour le moment.
      </p>
    </template>
    <Popin
      :visible="isYperTarifsShow"
      size="lg"
      @closed="isYperTarifsShow = false"
    >
      <div class="u-flex u-flex-column u-flex-align-center u-px-sm">
        <CmsFetcher link="/infos-et-services/pages-cachees/livraison-collaborative-yper" />
        <Button
          radius="full"
          variant="secondary"
          size="md"
          class="u-mt-lg u-mb-md"
          @click="isYperTarifsShow = false"
        >
          Ok, j’ai compris
        </Button>
      </div>
    </Popin>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/shipping-method-list.scss";
</style>
